import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Divider,
} from "@material-ui/core";

interface TitleDividerProps {
  title: string;
  hasItems?: boolean;
  dividerClassName?: any;
  color?: string
}
const useStyles = makeStyles(theme => ({
  line: {
    backgroundColor: theme.palette.primary.main,
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: 20,
    fontWeight: 500
  }
}));
export const TitleDivider = ({ title, hasItems = false, color, dividerClassName }: TitleDividerProps) => {
  const classes = useStyles();
  return (
    <Grid container alignItems="center" style={{ marginTop: 16, marginBottom: 16 }}>
      <Grid item>
        <Typography className={classes.title} variant="subtitle1" style={{ color: !hasItems && "rgba(0, 50, 89, 0.5)" }}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs>
        <Divider className={classes.line} />
      </Grid>
    </Grid>);
}